import React from "react"

const Container = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <div className="max-w-[650px] w-full mx-auto">{children}</div>
}

export default Container
